/** Give each player its own data: Lottie mutates it while rendering. */
export const prepareAnimation = (source: unknown): unknown => {
  const data: unknown = JSON.parse(JSON.stringify(source));

  const visit = (value: unknown) => {
    if (!value || typeof value !== "object") return;
    if (Array.isArray(value)) {
      value.forEach(visit);
      return;
    }

    const node = value as Record<string, unknown>;
    // Exported layer IDs repeat across icons; let Lottie generate unique IDs.
    delete node.ln;

    // Track mattes and white occlusion fills must retain their original colors.
    if (node.td) return;
    if (node.ty === "st" || node.ty === "fl") {
      const color = node.c as { k?: unknown } | undefined;
      const isWhite =
        Array.isArray(color?.k) &&
        color.k.slice(0, 3).every((channel) => channel === 1);
      if (!isWhite) {
        node.cl = [
          node.cl,
          node.ty === "st"
            ? "rujira-animated__stroke"
            : "rujira-animated__fill",
        ]
          .filter(Boolean)
          .join(" ");
      }
    }

    Object.values(node).forEach(visit);
  };

  visit(data);
  return data;
};
